// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1txRm","inner":"Footer_inner__1P-Nm"};